import { isEmpty } from 'lodash/fp';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import { IN_PERSON_TRAINING } from 'constants/actionTypes';
import { reloadEvent } from './index';
import * as attendeesActions from './attendees';
import {
  toggleUpdateEmailConfirmation,
  toggleTrainerChangeConfirmation,
} from './eventChangeManagement';

export function createSession(session) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { event } = getState();
      request
        .postJSON(routes.IN_PERSON_TRAINING.EVENT_SESSIONS(event.id), {
          event_id: event.id,
          session,
        })
        .then(res => {
          if (res.success) {
            resolve();
            dispatch({
              type: IN_PERSON_TRAINING.SESSIONS.CREATE,
              session: res.session,
            });
            dispatch(reloadEvent());
          }
        })
        .fail(reject);
    });
}

export function removeSession(session) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { event } = getState();
      request
        .delete(routes.IN_PERSON_TRAINING.EVENT_SESSION(event.id, session.id))
        .then(() => {
          resolve();
          dispatch({
            type: IN_PERSON_TRAINING.SESSIONS.REMOVE,
            session,
          });
          dispatch(attendeesActions.updateFilters({ page: 1 }));
          dispatch(reloadEvent());
        });
    });
}

export function updateSession(session, additionalParams = {}) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { event } = getState();
      request
        .putJSON(
          routes.IN_PERSON_TRAINING.EVENT_SESSION(event.id, session.id),
          {
            session,
            ...additionalParams,
          },
        )
        .then(res => {
          // If the request is made with the confirmation of removing the
          // current user as the trainer, then the user will no longer have
          // access to the event. In which case the user is redirected to the
          // events index page.
          if (additionalParams.trainer_change_confirmed) {
            window.location = routes.IN_PERSON_TRAINING.EVENTS;
            return;
          }

          /**
           * We're only asking users to confirm sending an update email when:
           * A) the session being edited is upcoming AND
           * B) the user has changed some attributes (changed_attributes not empty)
           * C) there are invitees listed on the event
           */
          if (
            res.session.upcoming &&
            !isEmpty(res.changed_attributes) &&
            res.session.has_invitees
          ) {
            dispatch(
              toggleUpdateEmailConfirmation({
                resource: {
                  id: res.session.id,
                  type: 'Session',
                },
                changedAttributes: res.changed_attributes,
              }),
            );
          }
          resolve(res);
          dispatch({
            type: IN_PERSON_TRAINING.SESSIONS.UPDATE,
            session: res.session,
          });
          dispatch(attendeesActions.requestAttendees());
          dispatch(reloadEvent());
        })
        .fail(error => {
          // The update request can fail if the user is a trainer of the session
          // AND changes it to another user. In which case the backend returns
          // a 428 (Precondition Required) error. This error is handled by
          // showing a special confirmation modal that makes the same request
          // but with additional params confirming the removal of current user
          // as the trainer of the event.
          if (error.status === 428) {
            dispatch(toggleTrainerChangeConfirmation(session));
            reject(error);
          } else {
            reject(error.responseJSON);
          }
        });
    });
}
